import { useRef, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";

export default function MicButton({ onText, testId, className = "" }) {
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);
  const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);
  if (!SR) return null;

  const toggle = () => {
    if (listening) { recRef.current?.stop(); return; }
    const rec = new SR();
    rec.lang = "it-IT";
    rec.interimResults = false;
    rec.maxAlternatives = 1;
    rec.onresult = (e) => { const t = e.results?.[0]?.[0]?.transcript?.trim(); if (t) onText(t); };
    rec.onend = () => setListening(false);
    rec.onerror = (e) => {
      setListening(false);
      if (e.error === "not-allowed") toast.error("Consenti l'accesso al microfono per usare la dettatura.");
    };
    recRef.current = rec;
    setListening(true);
    try { rec.start(); } catch (err) { setListening(false); }
  };

  return (
    <button type="button" onClick={toggle} title="Detta col microfono 🎤" aria-label="Detta col microfono"
      className={"p-1.5 rounded-md transition-colors " + (listening ? "bg-red-100 text-red-600 animate-pulse" : "text-slate-400 hover:text-[#14B8A6]") + " " + className}
      data-testid={testId}>
      {listening ? <MicOff className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
    </button>
  );
}
